import { Util } from "../../../../../utils/util";
import { CustomizeItemPremodifierBase, ICustomizeItemPremodifierBaseParams } from "../base/customize-item-premodifier-bar-base";

/**
 * Handles rendering and managing user selection of pre-modifiers (e.g., "No Cheese", "Extra Sauce")
 * for a specific modifier in the customize item flow.
 */
export class CustomizeItemPremodifierBarSingleItem extends CustomizeItemPremodifierBase<ICustomizeItemPremodifierBaseParams> {
    /**
     * Creates the root element containing the pre-modifier segmented button bar.
     *
     * @param {boolean} isSelected - Whether the modifier is currently selected.
     * @param {number[]} preModifierExceptions - IDs of pre-modifiers to exclude.
     * @returns {HTMLElement | null} The root element or null if no options.
     */
    protected _createPremodifierElement(params: ICustomizeItemPremodifierBaseParams): HTMLElement | null {
        const includeNonePreModifier = !this._selectionState.modifierDisplayGroup.MustToggle; // Bug #64171

        const element = this._createPreModifiersSelectionBar(
            this._selectionState.preModifierId,
            includeNonePreModifier,
            params.preModifierExceptions,
            !params.isSelected,
            "Premodifier Selection",
            `${this._selectionState.modifierDisplayGroup.ModifierDisplayGroupId}_${this._selectionState.modifierId}`
        );

        return element;
    }

    protected _createElement(): HTMLElement {
        const html = `
            <div id="div_customize_item_modifier_premodifier_selection_${this._selectionState.modifierDisplayGroup.ModifierDisplayGroupId}_${this._selectionState.modifierId}" class="customize-item-premodifier-selection">
            </div>
        `;

        return Util.createHtmlElementFromTemplate(html);
    }
}